<header class="pearson-header-neutral dashboard custom-brand-color">
  <h1 class="header-title">{{ siteHeaderDetail }}</h1>
    <a
        class="logout-link"
        [routerLink]="['/externalLogout']"
        >
        <fa-icon class="fa fa-lg fa-fw" icon="sign-out-alt" aria-hidden="true"></fa-icon>
        <span>{{ 'label.Logout' | translate | async }}</span>
    </a>
</header>
<div id="main-content">
    <vue-loading-indicator [loadingText]="'label.loading' | translate:'PortalBase' | async "></vue-loading-indicator>
    <vue-confirm-lose-changes-dialog></vue-confirm-lose-changes-dialog>
    <vue-timeout-dialog></vue-timeout-dialog>
    <div class="app-wrapper">
        <div class="app-container">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<vue-footer></vue-footer>
